import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-magazzino-rifiuti-cer',
  templateUrl: './magazzino-rifiuti-cer.component.html',
  styleUrls: ['./magazzino-rifiuti-cer.component.css']
})
export class MagazzinoRifiutiCerComponent implements OnInit {

  @ViewChild('uMagazzinoRifiutiCer', { static: true }) uMagazzinoRifiutiCer: NicaAnagraficaComponent

  @Input() idTabRif: any
  @Input() itemData


  filterString: string;
  listaCerMagazzino: any[]
  constructor(private myservice: AnagraficaService) { }

  ngOnInit() {
    console.log(this.idTabRif)

    if (this.idTabRif) {

      this.filterString = '/' + this.idTabRif
    }

    if (this.itemData) {
      this.idTabRif = '/' + this.itemData[0]['idTabRif'];
      this.filterString = '/' + this.idTabRif
    }

    this.myservice.getElenco('magazzinorifiuticer', this.idTabRif).then(resp => {

      this.listaCerMagazzino = resp['items'];
    })

  }

  magazzinoCerEvent(e) {


    if (e.name == 'onSaving') {
      console.log(e)

      const idCer = e.changes[0]['data']['cer'];
      const inList = e.component.getRowIndexByKey(idCer);




      if (idCer && e.changes[0]) {
        e.cancel = true;
        e.promise = this.getCer(idCer, e.changes[0], e);

      } else {
        e.cancel = true;
      }

      return e
      /*
      console.log("on saving ", e.changes);*/
    }
  }
  getCer(idCer, e, c) {

    console.log(c)
    if (e.type == "insert") {
      let checked = this.listaCerMagazzino.filter(row => row.cer == idCer)

      if (checked.length > 0) {
        alert('ERR già prensente', 'Attenzione!');
        c.promise = '';
        return

      } else {
        e['data']['idMagazzinoRifiuti'] = this.idTabRif

        let data = e['data'];

        this.myservice.actionInsert('MagazzinoRifiutiCer', data).then(res => {
          c.refresh()
          this.myservice.getElenco('magazzinorifiuticer', this.idTabRif).then(resp => {

            this.listaCerMagazzino = resp['items'];
          })

        })

      }
    }



  }
}
